import { useState } from 'react'
import {
  Form,
  FormFeedback,
  Alert,
  Spinner
  // @ts-ignore
} from 'reactstrap'
import { useForm } from 'react-hook-form'
//@ts-ignore
import Select from 'react-select'
import moment from 'moment'
//@ts-ignore
import classnames from 'classnames'
//@ts-ignore
import { useSupportService } from '../../../../_services/SupportService'
//@ts-ignore
import { Button, Input, Textarea } from 'dsm-react-lib'
import { toast } from 'react-toastify'
import { selectThemeColors } from '../../../../utility/Utils'

interface AliFeedbackFormProps {
  toggle?: () => void
}

const validationMessages = {
  subject: 'Subject is required.',
  description: 'Description is required.'
}

const options = [
  { value: 'Feedback', label: 'General Feedback' },
  { value: 'Feature Request', label: 'Feature Request' }
]

const AliFeedbackForm: React.FC<AliFeedbackFormProps> = ({ toggle }) => {
  const { register, errors, trigger, handleSubmit } = useForm({})
  const { isSending, raiseTicket } = useSupportService()
  const [subject, setSubject] = useState('')
  const [description, setDescription] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [option, setOption] = useState<any>()
  const [disableButton, setDisableButton] = useState(false)

  const onSubjectChange = (e: any) => {
    setSubject(e.target.value)
  }

  const onDescChange = (e: any) => {
    setDescription(e.target.value)
  }

  const onOptionChange = (e: any) => {
    if (e === null) {
      setOption(undefined)
    } else {
      setOption({ label: e.label, value: e.value })
    }
  }

  const onSubmit = async (e: any) => {
    e.preventDefault()
    if (option === undefined) setOption(null)

    const isValid = await trigger()
    if (isValid && option !== undefined && option !== null) {
      setDisableButton(true)
      const current_time = moment.utc().format('YYYYDDMM.HHmmssDD')
      const supportId = `SN${current_time}`
      const title = `${supportId} Ali- ${option?.value}`
      const ticket = {
        title,
        applicationName: option?.value,
        applicationID: 0,
        subject,
        description,
        supportType: 1
      }

      const response = await raiseTicket(ticket)
      return response.isSuccess
        ? (() => {
            toast.success('Ticket sent successfully!')
            return toggle && toggle()
          })()
        : setErrorMessage(
            `Sorry. Seems like we couldn't raise a request right now. Please try again later or reach us at analyticsplatform@mandg.com.`
          )
    }
  }

  return (
    <div className="relative pb-4">
      <div
        className={`h-[200px] w-full absolute top-0 left-0 right-0 z-0 chat-primary theme-bg`}></div>
      <div className="ps-3 pt-3 mb-2 relative z-10">
        <h3 className="section-header text-white">From improvements to feature requests,</h3>
        <h3 className="section-header text-white">we want to hear your thoughts.</h3>
      </div>
      <div className="shadow-xl bg-surface-muted mx-8 relative z-10 mt-6">
        <Form onSubmit={handleSubmit(onSubmit)} className="mx-2 pt-1">
          <div>
            <div className="form-group col-sm-12 p-1">
              <Input
                type="text"
                id="subject"
                name="subject"
                defaultValue={subject}
                ref={register({ required: true })}
                invalid={'subject' in errors}
                placeholder="Subject"
                onChange={async (e: any) => {
                  await trigger('subject')
                  onSubjectChange(e)
                }}
                helperText={errors.subject ? validationMessages.subject : ''}
                data-testid="needHelpSubject"
              />
            </div>
            <div className="form-group col-md-12 p-1 pt-0">
              <Select
                placeholder="Query type"
                name="select"
                id="portal"
                options={options}
                value={option}
                theme={selectThemeColors}
                className={classnames('react-select', {
                  'is-invalid': option === null
                })}
                classNamePrefix="select"
                onChange={onOptionChange}
                isClearable={true}
                data-testid="needHelpDropdown"
              />
              {option === null && <FormFeedback>Selection is required.</FormFeedback>}
            </div>
            <div className="form-group col-md-12 p-1 pt-0">
              <Textarea
                id="description"
                name="description"
                ref={register({ required: true })}
                invalid={'description' in errors}
                placeholder="Description"
                onChange={async (e: any) => {
                  await trigger('description')
                  onDescChange(e)
                }}
                helperText={errors.description ? validationMessages.description : ''}
                data-testid="needHelpDescription"
              />
            </div>
          </div>
          <div className="pb-3 mx-1 mt-1">
            <Button
              className="d-flex justify-content-center align-items-center"
              label={
                isSending ? (
                  <>
                    <Spinner size="sm" />
                    &nbsp; Sending ticket
                  </>
                ) : (
                  'Send ticket'
                )
              }
              type="submit"
              color="var(--color-primary)"
              variant="fill"
              block
              onClick={onSubmit}
              disabled={disableButton}
              data-testid="sendTicketBtn"
            />
          </div>
        </Form>
      </div>
      {errorMessage !== '' && (
        <Alert className="m-1 px-1 py-1" color="danger">
          {errorMessage}
        </Alert>
      )}
    </div>
  )
}

export default AliFeedbackForm
